module.exports = __webpack_public_path__ + "img/ke.9da286d5.svg";